class StreamingManager {
    constructor() {
        this.data = {};
        this.listeners = new Set();
    }

    subscribe(fn) {
        this.listeners.add(fn);
        return () => this.listeners.delete(fn);
    }

    notify() {
        for (const fn of this.listeners) fn(this.data);
    }

    ingest({ recordId, conversationId, chunk, done }) {
        if (!recordId) return;
        const prev = this.data[recordId] || {
            recordId,
            conversationId,
            text: "",
            done: false,
            started: false,
        };
        const hasChunk = typeof chunk === "string" && chunk.length > 0;
        const next = {
            ...prev,
            text: hasChunk ? prev.text + chunk : prev.text,
            done: !!done,
            started: prev.started || hasChunk,
        };
        this.data[recordId] = next;
        this.notify();
        return next;
    }

    get(recordId) {
        return this.data[recordId];
    }

    getText(recordId) {
        return this.data[recordId]?.text || "";
    }

    isStreaming(recordId) {
        return !!this.data[recordId] && !this.data[recordId].done;
    }

    remove(recordId) {
        if (this.data[recordId]) {
            delete this.data[recordId];
            this.notify();
        }
    }

    clearConversation(conversationId) {
        let changed = false;
        Object.keys(this.data).forEach((id) => {
            if (this.data[id].conversationId === conversationId) {
                delete this.data[id];
                changed = true;
            }
        });
        if (changed) this.notify();
    }

    getAll() {
        return this.data;
    }
}

export const streamingManager = new StreamingManager();